// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"7d511e28","242":"f245344e","390":"f4956838","431":"c7750216","492":"5c90cbd8","667":"d17a4fdc","696":"06ca8fdb","787":"8b6a91c2","990":"d56f1e0b"}[chunkId] + ".chunk.js";
};